import { render, staticRenderFns } from "./columnsBtn.vue?vue&type=template&id=763f8143&scoped=true&"
import script from "./columnsBtn.vue?vue&type=script&lang=js&"
export * from "./columnsBtn.vue?vue&type=script&lang=js&"
import style0 from "./columnsBtn.vue?vue&type=style&index=0&id=763f8143&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763f8143",
  null
  
)

export default component.exports